import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const samRepresentationSliceName = "samRepresentation";

export interface RepresentationSelection {
  geometryEntryId: string | undefined;
  representationIds: string[];
}

export interface SamRepresentationState {
  selection: RepresentationSelection;
}

const initialState: SamRepresentationState = {
  selection: {
    geometryEntryId: undefined,
    representationIds: [],
  },
};

const samSlice = createSlice({
  name: samRepresentationSliceName,
  initialState,
  reducers: {
    setRepresentationSelection(state: SamRepresentationState, action: PayloadAction<RepresentationSelection>) {
      state.selection = action.payload;
    },
    clearRepresentationSelection(state: SamRepresentationState) {
      state.selection = {
        geometryEntryId: undefined,
        representationIds: [],
      };
    },
  },
});

export interface SamRepresentationRootState {
  [samRepresentationSliceName]: SamRepresentationState;
}

export const selectSamRepresentation = (state: SamRepresentationRootState) => state[samRepresentationSliceName];
export const selectSamRepresentationSelection = (state: SamRepresentationRootState) => {
  return selectSamRepresentation(state).selection;
};

export const {
  setRepresentationSelection,
  clearRepresentationSelection,
} = samSlice.actions;
export const samRepresentationReducer = samSlice.reducer;
